import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
  screenShotTableData: {
    head: [],
    body: []
  },
  isTableLoading: true,
  screenShots: [],
  list: [],
  listImages: [],
  screenshotListLoading: false,
  isScreenShotInterval: true
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUCCESS_SCREENSHOT_TABLE:
      var data = action.data.screnshotRequestList.map(i => {
        return [i.userName, i.accountName, i.fromTime, i.toTime, {configurationDownloadTime:i.configurationDownloadTime}, i.mins, i.imagesPerminute, { id: i.id, status: i.status, failureRemark: i.failureRemark, fromDate: i.fromTime, toDate: i.toTime, actualFromDate: i.actualFromTime, actualToDate: i.actualToTime, ConfigurationDate: i.configurationDownloadTime }]
      })
      return {
        ...state,
        screenShotTableData: {
          head: [
            { label: "User Name", align: "left", isFilter: true, filterVal: null, index: 0 },
            { label: "Account Name", align: "left", isFilter: true, filterVal: null, index: 1 },
            {
              label: "From DateTime", align: "left"
              // ,isFilter: true, filterVal: { startDate: null, endDate: new Date(""), key: 'selection' }, isDateSelection: true, index: 2 
            },
            { label: "To DateTime", align: "left" },
            { label: "Configuration Time", align: "left" },
            { label: "Minutes", align: "left" },
            { label: "Images", align: "left" },
            { label: "Action", align: "right" }
          ],
          body: data
        },
        isScreenShotInterval: true,
        screenShots: action.data.screnshotRequestFileNameList
      }
    case types.FAIL_SCREENSHOT_TABLE:
      return {
        ...state,
        screenShotTableData: {
          head: [],
          body: []
        },
        isScreenShotInterval: true
      }
    case types.SUCCESS_SCREENSHOT_LIST:
      var data = {}
      data = action.data.screnshotRequestList.map((value) => {
        var screenShotList = []
        action.data.screnshotRequestFileNameList.filter(item => item.id == value.id).map((values) => {
          screenShotList.push(values.fileName)
        })
        return { id: value.id, userName: value.userName, fromDate: value.fromTime, toDate: value.toTime, actualFromDate: value.actualFromTime, actualToDate: value.actualToTime, configurationDownloadDate: value.configurationDownloadTime, images: screenShotList }
      });
      return {
        ...state,
        list: data,
        listImages: action.data.screnshotRequestFileNameList
      }
    case types.SORT_BY_FROMDATE_A_Z:
      var sortdata = {}
      sortdata = state.list.sort((a, b) => {
        return (new Date(a.fromDate) < new Date(b.fromDate)) ? -1 : (new Date(a.fromDate) > new Date(a.fromDate)) ? 1 : 0;
      })
      return {
        ...state,
        list: sortdata,
      }
    case types.SORT_BY_FROMDATE_Z_A:
      var sortdata = {}
      sortdata = state.list.sort((a, b) => {
        return (new Date(a.fromDate) > new Date(b.fromDate)) ? -1 : (new Date(a.fromDate) < new Date(a.fromDate)) ? 1 : 0;
      })
      return {
        ...state,
        list: sortdata,
      }
    case types.FAIL_SCREENSHOT_LIST:
      return {
        ...state,
        list: [],
        listImages: []
      }
    case types.LOADING_SCREENSHOT_LIST:
      return {
        ...state,
        screenshotListLoading: action.data
      }
    case types.LOADING_SCREENSHOT_TABLE:
      return {
        ...state,
        isTableLoading: action.data
      }
    case types.SCREENSHOT_TABLELOADER:
      return {
        ...state,
        isTableLoading: action.data
      }
    case types.FETCH_SCREENSHOT_TABLE:
      return {
        ...state,
        isScreenShotInterval: false
      }
    default:
      return state
  }

}
export default reducer
